// extracted by mini-css-extract-plugin
export default {"floating-notification":"AGvg6C","floatingNotification":"AGvg6C"};